/**
 * See the NOTICE file distributed with this work for additional information
 * regarding copyright ownership.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import classNames from 'classnames';

import SVGIcon from 'static/icons/icon_launchbar_entity_viewer.svg';

import styles from './AppIcon.module.css';

const EntityViewerIcon = (props: { className?: string }) => {
  const elementClasses = classNames(
    styles.appIcon,
    styles.entityViewer,
    props.className
  );

  return (
    <div className={elementClasses}>
      <SVGIcon />
    </div>
  );
};

export default EntityViewerIcon;
